/**
 * The company section, verbatim.
 *
 * Lifted unchanged from the approved design and kept that way on instruction. It is the one part of
 * this page whose claims are not derived from anything: the roadmap items, the shipped dates and the
 * "15 שדות" inside the third card are written copy, not figures the product hands us. Every other
 * number on the landing page comes from `/plans` or `/overview` — this section is the exception, and
 * it is an exception by decision rather than by omission.
 *
 * Split into data here rather than left as markup so the two lists stay obviously parallel: what is
 * running, and what has already shipped. `soon` is the only thing that distinguishes a card visually,
 * and the closing note is what tells a reader how to read both tags.
 */

export const CO_LEAD_BEFORE = 'אנחנו צוות קטן שמשתמש במודלים כדי לעשות עבודה שאף אחד לא מוכן לעשות ביד: ';
export const CO_LEAD_STRONG = 'לקרוא כל מכרז שמתפרסם בישראל, כל בוקר, ולפרק אותו לשדות.';
export const CO_LEAD_AFTER = ' מה שאתה רואה עכשיו זה הרצפה, לא התקרה — ואנחנו שולחים כל שבוע.';

export const CO_NOTE =
  'מה שכתוב "רץ בבדיקות" קיים אצלנו עכשיו. מה שכתוב "בעבודה" נבנה כרגע. מה שלא ברשימה — לא הבטחנו, ' +
  'ואין כאן תאריכי יעד על דברים שעוד לא נשלחו.';

export interface BuildItem {
  tag: string;
  title: string;
  body: string;
  /** Not yet running anywhere — rendered quieter, and the closing note explains the difference. */
  soon: boolean;
}

export const BUILDING: BuildItem[] = [
  {
    tag: 'רץ בבדיקות',
    title: 'סוכן שמגיש איתך',
    body:
      'הוא כבר קורא את תנאי הסף ואת אופן ההגשה של כל מכרז. הצעד הבא: שימלא איתך את הטפסים, יגיד לך מה ' +
      'חסר, ויתריע לפני כל שער — מפגש מציעים, שאלות הבהרה, הגשה.',
    soon: false,
  },
  {
    tag: 'רץ בבדיקות',
    title: 'התראות לפי הפרופיל שלך',
    body:
      'לא עוד רשימת תפוצה. הסוכן מכיר את התחום, האזור והסיווג שלך — ושולח בוקר אחד, מייל אחד, רק מה ' +
      'שרלוונטי.',
    soon: false,
  },
  {
    tag: 'בעבודה',
    title: 'קריאה עמוקה של המסמכים',
    body:
      'היום אנחנו מחלצים 15 שדות מכל פרסום. הבא בתור: כתב הכמויות והאומדן — כדי שתדע אם שווה לך לגשת ' +
      'בלי לפתוח את החוברת.',
    soon: true,
  },
  {
    tag: 'בעבודה',
    title: 'סינון לפי סיווג קבלן',
    body:
      'ענף וסיווג של רשם הקבלנים, כמו שאתה כבר עובד — כדי שלא תראה מכרזים שאתה לא יכול לגשת אליהם בכלל.',
    soon: true,
  },
];

export interface ShipItem {
  date: string;
  what: string;
}

export const SHIPPED: ShipItem[] = [
  { date: '14.08', what: 'נוספו 4 מועצות אזוריות בצפון' },
  { date: '21.07', what: 'תנאי סף הפך לשדה שאפשר לסנן לפיו' },
  { date: '09.07', what: 'תצוגת טבלה עם מיון וייצוא' },
  { date: '28.06', what: 'נוספה רשות הטבע והגנים' },
  { date: '12.06', what: 'נוספה עיריית אילת' },
];
